import { scaleLinear } from 'd3-scale';
import { color } from 'd3-color';

export function colorScale(margin) {
  if (isNaN(margin)) {
    return '#c6c6c6';
  } else {
    let assignColor = scaleLinear()
      .domain([-40, -20, -0.1, 0, 0.1, 20, 40])
      .range([
        '#8f68bb',
        '#af96c0',
        '#cfc0d9',
        '#e3e3e3',
        '#c7d5d2',
        '#9bbbb3',
        '#3a7364',
      ])
      .clamp(true);

    let finalColor = assignColor(margin * 100);
    finalColor = color(finalColor).formatHex();

    return finalColor;
  }
}
